// test2825
(2825 && 0);
